

interface Settings{
    start: number;
    noRepeat: boolean;
    fast:boolean
    loop?: number
}

const defaults : Settings = {
    start: 0,
    fast: false,
    noRepeat: false,
    loop: undefined
}

const params = Object.fromEntries(new URLSearchParams(window.location.search).entries());


export const settings : Settings = Object.assign( {},defaults, {
    start: "start" in params ? parseInt(params.start) : 0,
    fast: "fast" in params,
    noRepeat: "noRepeat" in params,
    loop: "loop" in params ? parseInt(params.loop) : undefined,
})

console.log(settings)